import {
	Button,
	FormControl,
	Grid,
	InputLabel,
	MenuItem,
	Paper,
	Select,
} from "@material-ui/core";
import React, { useState } from "react";
import config from "react-global-configuration";
import Cabecalho from "../../components/Pagina/Cabecalho";

const CancelarPagina = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const [formData, setFormData] = useState({
		motivoCancelamento: "",
		cancelarId:
			urlParams.get("cancelarId") !== "" ? urlParams.get("cancelarId") : "",
	});

	const motivoHandler = (field, e) => {
		setFormData({ ...formData, [field]: e.target.value });
	};

	const cancelar = () => {
		fetch(
			config.get("url_api") +
				"orcamento/cancelar-pedido/" +
				formData.cancelarId,
			{
				method: "POST",
				headers: {
					"Content-Type": "application/json;charset=utf-8",
				},
				body: JSON.stringify({
					motivoCancelamento: formData.motivoCancelamento,
				}),
			}
		)
			.then((res) => res.json())
			.then((result) => {
				if (result.success) {
					window.location.href =
						"https://metalife2.pipedrive.com/deal/" +
						result.orcamento.negocio_id;
				} else {
					alert("Erro ao cancelar pedido");
				}
			});
	};

	return (
		<React.Fragment>
			<Cabecalho title={"Cancelar orçamento"}></Cabecalho>
			<div className="p-1">
				<Grid container spacing={2} justify="center">
					<Grid item xs={4}>
						<Paper className="p-1">
							<FormControl fullWidth>
								<InputLabel id="motivoCancelamento-label">
									Motivo do cancelamento
								</InputLabel>
								<Select
									id="motivoCancelamento"
									value={formData.motivoCancelamento}
									onChange={(e) => motivoHandler(["motivoCancelamento"], e)}
								>
									<MenuItem value={"CANCELAMENTO ANTES DO PAGAMENTO"}>
										CANCELAMENTO ANTES DO PAGAMENTO
									</MenuItem>
									<MenuItem value={"CANCELAMENTO COM REEMBOLSO"}>
										CANCELAMENTO COM REEMBOLSO
									</MenuItem>
									<MenuItem value={"MOTIVOS FINANCEIROS"}>
										MOTIVOS FINANCEIROS
									</MenuItem>
								</Select>
							</FormControl>
							<Button
								variant="contained"
								color="secondary"
								className="mt-1"
								disabled={
									formData.motivoCancelamento === "" &&
									formData.cancelarId !== ""
								}
								onClick={() => cancelar()}
							>
								Enviar
							</Button>
						</Paper>
					</Grid>
				</Grid>
			</div>
		</React.Fragment>
	);
};

export default CancelarPagina;
